export const FB_GTC_DURATION = '-1'

export enum Condition {
  USED = 'used',
  REFURBISHED = 'refurbished',
  NEW = 'new'
}

export enum Gender {
  UNISEX = 'unisex',
  FEMALE = 'female',
  MALE = 'male'
}

export enum Material {
  COTTON = 'cotton',
  DENIM = 'denim',
  LEATHER = 'leather'
}

export const ConditionOptions = [
  {
    label: 'Used',
    value: Condition.USED
  },
  {
    label: 'Refurbished',
    value: Condition.REFURBISHED
  },
  {
    label: 'New',
    value: Condition.NEW
  }
]

export const GenderOptions = [
  {
    label: 'Unisex',
    value: Gender.UNISEX
  },
  {
    label: 'Female',
    value: Gender.FEMALE
  },
  {
    label: 'Male',
    value: Gender.MALE
  }
]

export const MaterialOptions = [
  { label: 'None', value: null },
  {
    label: 'Cotton',
    value: Material.COTTON
  },
  {
    label: 'Denim',
    value: Material.DENIM
  },
  {
    label: 'Leather',
    value: Material.LEATHER
  }
]
